let cachedPlacesSDK = null;
let requestedPlacesSDK = null;
const source = 'https://maps.googleapis.com/maps/api/js?libraries=places&key=';

const loadGooglePlacesSDK = GOOGLE_MAPS_KEY => {
  if (cachedPlacesSDK) {
    return Promise.resolve(cachedPlacesSDK);
  }

  if (requestedPlacesSDK) {
    return requestedPlacesSDK;
  }

  requestedPlacesSDK = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = `${source}${GOOGLE_MAPS_KEY}`;
    script.addEventListener(
      'load',
      loadedSDK => {
        cachedPlacesSDK = loadedSDK;
        resolve(script);
      },
      false
    );
    script.addEventListener('error', () => reject(script), false);
    document.body.appendChild(script);
  });

  return requestedPlacesSDK;
};

export default loadGooglePlacesSDK;
